/* unplugin-vue-components disabled */import script from "./ModelInclusion.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModelInclusion.vue?vue&type=script&lang=ts&setup=true"

import "./ModelInclusion.vue?vue&type=style&index=0&id=40a18e24&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a18e24"]])

export default __exports__